export type CreditNoteModel = {
  cache_key: number,
  campaign_id?: number,
  contact_name?: string,
  creditor_type?: string,
  creditor_id?: number,
  data?: any,
  dates?: any,
  id: number,
  notes?: string,
  reference?: string,
  total: number,
  type: 'CreditNote',
}

export type CreditNoteRequestOptions = {
  include_credit_note_campaign?: boolean,
  include_credit_note_items?: boolean,
  include_invoice_attachment_file?: boolean,
  include_invoice_attachments?: boolean,
  include_invoice_campaign?: boolean,
  include_invoice_creditor?: boolean,
  include_invoice_items?: boolean,
}

const state = {
  campaign_id: undefined,
  contact_name: '',
  creditor_id: undefined,
  creditor_type: '',
  id: null,
  notes: '',
  reference: '',
}

export const requiredFields = []

export default state
